import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "parkingFilled"
const ParkingFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.757 8.438 12.82 8.44C12.88 8.445 12.972 8.453 13.083 8.47 13.311 8.502 13.6 8.567 13.874 8.687S14.377 8.967 14.536 9.176C14.685 9.37 14.813 9.66 14.813 10.125S14.685 10.879 14.536 11.075C14.377 11.281 14.149 11.442 13.874 11.562S13.311 11.748 13.084 11.78C12.971 11.797 12.88 11.805 12.82 11.809L12.757 11.813H10.687V8.437z" />
          <path
            fillRule="evenodd"
            d="M19.584 2.25C20.78 2.25 21.75 3.22 21.75 4.417V19.584C21.75 20.78 20.78 21.75 19.584 21.75H4.417C3.22 21.75 2.25 20.78 2.25 19.584V4.417C2.25 3.22 3.22 2.25 4.417 2.25zM8.813 6.563V17.25H10.687V13.688H12.75V12.75 13.688H12.772L12.811 13.687 12.938 13.68C13.04 13.674 13.185 13.66 13.354 13.637 13.69 13.588 14.151 13.489 14.626 13.281S15.623 12.741 16.026 12.211C16.44 11.668 16.689 10.973 16.689 10.125S16.44 8.582 16.026 8.039C15.623 7.51 15.1 7.177 14.626 6.97S13.689 6.662 13.354 6.613C13.184 6.588 13.041 6.576 12.938 6.569L12.81 6.563H12.75L12.75 7.053V6.563z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ParkingFilledIcon
